import { getApiFunctions } from "../api";

export const generateQRCode = ({ id }, callback) => {
  const functions = getApiFunctions().client.clientDepositBailiffQRGenerate;
  const options = { id };
  functions(options)
    .then((res) => {
      console.log(res);
      const data = res?.data;
      callback && callback({ status: 200, data });
    })
    .catch((err) => {
      console.error(err);
      callback &&
        callback({ status: 500, data: err?.message || "Invalid error" });
    });
};
